import _ from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { Header, Input, InputOnChangeData, Table } from 'semantic-ui-react';
import CategoriesRelationsRepo from '../../../../../utils/repository/categoriesRelationsRepo';
import { RelationsType, TableModelType } from './types';
import { getTableModel } from './utils';
import Loader from '../../../../../components/loader';
import { Link } from 'react-router-dom';

const SEARCH_DEBOUNCE_TIME = 200; // time is in ms

const CategoriesRelations = () => {
    const [tableModel, setTableModel] = useState<TableModelType>([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        setLoading(true);
        CategoriesRelationsRepo.getRelations((res: RelationsType) => {
            setTableModel(getTableModel(res));
            setLoading(false);
        });
    }, []);

    const handleSearchChange = useCallback(
        _.debounce(
            (__: React.ChangeEvent<HTMLInputElement>, { value }: InputOnChangeData) => setSearchTerm(value),
            SEARCH_DEBOUNCE_TIME
        ),
        []
    );

    return (
        <>
            <Header textAlign="center" as="h3">
                Categories Relations
            </Header>
            {loading ? (
                <Loader />
            ) : (
                <>
                    <Input icon="search" placeholder="Search by Category Name" onChange={handleSearchChange} />
                    <Table celled striped structured>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Category Name</Table.HeaderCell>
                                <Table.HeaderCell>Company Name</Table.HeaderCell>
                                <Table.HeaderCell>Schema Name</Table.HeaderCell>
                                <Table.HeaderCell>Field Name</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {tableModel
                                .filter((category) => category.categoryName.includes(searchTerm))
                                .map((category) => {
                                    const companiesIds = Object.keys(category.companiesMap);

                                    return companiesIds.map((companyId, companyIdIndex) => {
                                        const company = category.companiesMap[companyId];
                                        const schemaIds = Object.keys(company.schemasMap);

                                        return schemaIds.map((schemaId, schemaIdIndex) => {
                                            const schema = company.schemasMap[schemaId];
                                            const descriptors = schema.descriptors;
                                            const schemaRowSpan = descriptors.length;

                                            return descriptors.map((descriptor, descriptorIndex) => {
                                                return (
                                                    <Table.Row key={descriptor.descriptorLabel + descriptorIndex}>
                                                        {companyIdIndex === 0 &&
                                                        schemaIdIndex === 0 &&
                                                        descriptorIndex === 0 ? (
                                                            <Table.Cell
                                                                verticalAlign="top"
                                                                rowSpan={category.descriptorsCount}
                                                            >
                                                                {category.categoryName}
                                                            </Table.Cell>
                                                        ) : null}
                                                        {schemaIdIndex === 0 && descriptorIndex === 0 ? (
                                                            <Table.Cell
                                                                verticalAlign="top"
                                                                rowSpan={company.descriptorsCount}
                                                            >
                                                                <Link
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    to={`/admin/companies/${company.companyId}`}
                                                                >
                                                                    {company.companyName}
                                                                </Link>
                                                            </Table.Cell>
                                                        ) : null}
                                                        {descriptorIndex === 0 ? (
                                                            <Table.Cell verticalAlign="top" rowSpan={schemaRowSpan}>
                                                                {schema.schemaName}
                                                            </Table.Cell>
                                                        ) : null}
                                                        <Table.Cell>{descriptor.descriptorLabel}</Table.Cell>
                                                    </Table.Row>
                                                );
                                            });
                                        });
                                    });
                                })}
                        </Table.Body>
                    </Table>
                </>
            )}
        </>
    );
};

export default CategoriesRelations;
